import { useLayoutEffect, useRef, type RefObject } from 'react'
import { useReducedMotion } from '../../app/hooks'

export function usePlaceTransition(ref: RefObject<HTMLElement | null>, place: string) {
  const previous = useRef(place)
  const reduced = useReducedMotion()
  useLayoutEffect(() => {
    if (previous.current === place) return
    previous.current = place
    if (reduced) return
    // All bindings have committed. Only the new reading travels; no old numbers cross-fade.
    const animations = [...ref.current?.querySelectorAll<HTMLElement>('.v5-current,.v5-story h1,.v5-time-readout') ?? []]
      .map(node => node.animate?.([{ opacity: .86, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 180, easing: 'cubic-bezier(.16,1,.3,1)' }))
    return () => animations.forEach(animation => animation?.cancel())
  }, [place, reduced, ref])
}
